<template>
    <el-date-picker
      v-model="value"
      :type="data.dateRange||'date' "
      placeholder="选择日期"
      :format="data.dateRange==='month'?'yyyy 年 MM 月':'yyyy 年 MM 月 dd 日'"
      :disabled="disabled"
      value-format="yyyy-MM-dd"
      @change="change"
      class="input-form"
    ></el-date-picker>
</template>

<script>
export default {
  props: ["data", "modelDat", "disableStatus"],

  data() {
    return {
      value: "",
      disabled: false,
      itemDisabled: false
    };
  },

  methods: {
    change() {
      this.$emit("inputChange", {
        key: this.data.field,
        value: this.value
      });
    }
  },

  watch: {
    modelDat(newValue) {
      this.value = newValue;
    }
  },

  mounted(){
    if (this.data.disabled) {
      this.itemDisabled = true;
    }
    this.disabled = this.disableStatus || this.itemDisabled;
  }

};
</script>

